import {
  IntervalType,
  SuraasaPlusProduct,
} from "api/resources/suraasaPlus/types"

export enum PlanMode {
  ANNUAL = "annual",
  QUARTERLY = "quarterly",
  MONTHLY = "monthly",
}

export const getPlanDisplayData = (options: {
  intervalType: IntervalType
  billingInterval: number
}) => {
  switch (options.intervalType) {
    case IntervalType.year:
      return {
        label: "Annual",
        planMode: PlanMode.ANNUAL,
        description: "1-year access. No auto-renewal.",
        planDurationText: "/year",
      }
    case IntervalType.month:
      return options.billingInterval === 3
        ? {
            label: "Quarterly",
            planMode: PlanMode.QUARTERLY,
            description: "Auto-renewal. Cancel anytime.",
            planDurationText: "/quarter",
          }
        : {
            label: "Monthly",
            planMode: PlanMode.MONTHLY,
            description: "Auto-renewal. Cancel anytime.",
            planDurationText: "/month",
          }
    case IntervalType.week:
      throw new Error("Weekly plan mode is not supported")
    case IntervalType.day:
      throw new Error("Daily plan mode is not supported")
  }
}

export const getProductByPlanMode = (
  products: SuraasaPlusProduct[],
  plan: IntervalType
) => {
  return products.find(p => p.subscriptionDetails?.intervalType === plan)
}

export const getPlanModeBySubscriptionIntervalType = (options: {
  intervalType: IntervalType
  billingInterval: number
}): PlanMode => {
  switch (options.intervalType) {
    case IntervalType.year:
      return PlanMode.ANNUAL
    case IntervalType.month:
      return options.billingInterval === 3
        ? PlanMode.QUARTERLY
        : PlanMode.MONTHLY

    case IntervalType.week:
      throw new Error("Weekly plan mode is not supported")
    case IntervalType.day:
      throw new Error("Daily plan mode is not supported")
  }
}
